"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [!_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/clients-contacts/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&createdBy=${_vm.selectedAdminId}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-user"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "new-contacts1"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("New Contacts")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.clientCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), _vm.isUserAdminOrSuperAdmin ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/clients-contacts/list?approval=true`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-puzzle"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "agent"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Website Pending Contacts")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.clientApprovalCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), _vm.isUserSuperAdmin ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-list"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "total-inquiries"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Total Inquiries")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), _vm.isUserSuperAdmin ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&isSuperAdminTask=true`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-approval-list"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "open-inquiries"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Pending Approval FollowUps")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.followUpApprovalCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), _vm.isUserSuperAdmin ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&status=Won`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-trophy"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "won"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Won")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadWonCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), _vm.isUserSuperAdmin ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&status=Lost`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-puzzle"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "lost"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Lost")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadLostCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), !_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&statuses=New,Contacted`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-puzzle"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "open-inquiries"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Open")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadOpenCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), !_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&noFollowup=true`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-puzzle"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "no-followup"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("No FollowUp")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadNoFollowUpCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), !_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&missedFollowUp=true`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-puzzle"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "missed-followup"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Missed FollowUp")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.leadMissedFollowUpCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), !_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/leads/list?createdTimestamp=${_vm.startDate},${_vm.endDate}&salesManagerId=${_vm.selectedAdminId}&salesCoordinatorId=${_vm.selectedAdminId}&createdBy=${_vm.selectedAdminId}&isQuotationSent=true`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-box"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "quotation-sent"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Quotation Sent")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.quoteSentCount,
      duration: 10
    }
  })], 1)])])])], 1) : _vm._e(), !_vm.isDispatcher ? _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;